import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100 py-4 d-flex flex-column align-items-center justify-content-center" }
const _hoisted_2 = { style: {"width":"24rem"} }
const _hoisted_3 = {
  style: {"font-size":"var(--font-lg)"},
  class: "mb-3 text-black text-center"
}
const _hoisted_4 = { style: {"margin":"0 auto","width":"100%","max-width":"10rem"} }

import { useRouter } from "vue-router";

import { Button } from "@/components/global";
import { NoPlanSvg } from "@/components/svg";

interface Props {
  message?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NoPlanView',
  props: {
    message: {}
  },
  setup(__props: any) {


const router = useRouter();

const goToPlan = () => {
  router.push("/manage-plan");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(NoPlanSvg))
    ]),
    _createElementVNode("span", _hoisted_3, _toDisplayString(__props.message ?? "You need to choose a plan to access this feature"), 1),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(Button), {
        rounded: "lg",
        onClick: goToPlan,
        testId: "choose-plan-btn"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" Choose Plan ", -1)
        ]))]),
        _: 1
      })
    ])
  ]))
}
}

})